var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProgress = function SvgProgress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84088 12.4091C8.21743 12.4091 8.52271 12.7144 8.52271 13.0909V15.8182C8.52271 16.1948 8.21743 16.5 7.84088 16.5C7.46433 16.5 7.15905 16.1948 7.15905 15.8182V13.0909C7.15908 12.7144 7.46436 12.4091 7.84088 12.4091Z",
    fill: "#9300C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6207 11.2825C10.9634 11.1265 11.3677 11.2778 11.5237 11.6205L12.6537 14.1027C12.8097 14.4454 12.6584 14.8497 12.3157 15.0058C11.973 15.1618 11.5686 15.0104 11.4126 14.6677L10.2826 12.1856C10.1266 11.8428 10.278 11.4385 10.6207 11.2825Z",
    fill: "#F3E4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84088 1.5C8.21743 1.5 8.52271 1.80527 8.52271 2.18183V4.9091C8.52271 5.28565 8.21743 5.59093 7.84088 5.59093C7.46433 5.59093 7.15905 5.28565 7.15905 4.9091V2.18183C7.15908 1.80527 7.46436 1.5 7.84088 1.5Z",
    fill: "#DAA1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4662 11.4106C4.73242 11.1443 5.16417 11.1443 5.43042 11.4106C5.6967 11.6768 5.6967 12.1086 5.43042 12.3748L3.50192 14.3033C3.3688 14.4364 3.19433 14.503 3.01984 14.503C2.84535 14.503 2.67083 14.4365 2.5377 14.3033C2.27142 14.037 2.27142 13.6053 2.5377 13.3391L4.4662 11.4106Z",
    fill: "#A900E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H15C15.5523 9 16 9.22386 16 9.5C16 9.77614 15.5523 10 15 10H13C12.4477 10 12 9.77614 12 9.5C12 9.22386 12.4477 9 13 9Z",
    fill: "#F3E4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1801 3.69672C12.4463 3.43044 12.878 3.43044 13.1443 3.69672C13.4105 3.963 13.4106 4.39472 13.1443 4.66094L11.2158 6.5894C11.0827 6.72253 10.9082 6.78912 10.7337 6.78912C10.5592 6.78912 10.3847 6.72253 10.2516 6.5894C9.98536 6.32312 9.98536 5.89144 10.2516 5.62519L12.1801 3.69672Z",
    fill: "#F3E4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02278 8.31818H3.75006C4.12661 8.31818 4.43188 8.62345 4.43188 9C4.43188 9.37655 4.12661 9.68183 3.75006 9.68183H1.02278C0.64623 9.68183 0.340957 9.37655 0.340957 9C0.340957 8.62345 0.64623 8.31818 1.02278 8.31818Z",
    fill: "#CC72FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50192 3.69672L5.43042 5.62519C5.6967 5.89141 5.6967 6.32315 5.43042 6.5894C5.29729 6.72253 5.12277 6.78912 4.94834 6.78912C4.77387 6.78912 4.59932 6.72253 4.4662 6.5894L2.5377 4.66094C2.27142 4.39472 2.27142 3.96297 2.5377 3.69672C2.80392 3.43044 3.23564 3.43044 3.50192 3.69672Z",
    fill: "#CC72FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/progress.88ec3548.svg";
export { ForwardRef as ReactComponent };